import { action, observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';

class ActivityConfigStore extends BaseStore {
  @observable account = '';
  @observable isReserved = false;
  @observable serverName = '新服名称';
  @observable reservationCount = 0;
  @observable bindGold = 0;
  @observable bindGoldText = '0';
  @observable purchasePhase = 'closed';

  /**
   * 将接口字段收敛为页面使用的稳定名称。
   * @param {Object} data get_config 返回数据
   * @returns {{account: string, isReserved: boolean, serverName: string, reservationCount: number, bindGold: number, bindGoldText: string, purchasePhase: string}} 页面配置 ViewModel
   */
  normalizeConfig(data) {
    const reservationCount = Number(data && data.total_activate);
    const bindGold = Math.max(0, Number(data && data.bind_gold) || 0);
    const purchasePhase = Number(data && data.buy_status) === 1 ? 'presale' : Number(data && data.v_exp_time_status) === 1 ? 'supplemental' : 'closed';
    return {
      account: (data && data.account) || '',
      isReserved: Number(data && data.reserve_status) === 1,
      serverName: (data && data.server_name) || '新服名称',
      reservationCount: Number.isFinite(reservationCount) && reservationCount >= 0 ? Math.floor(reservationCount) : 0,
      bindGold,
      bindGoldText: bindGold >= 10000 ? `${bindGold / 10000}万` : String(bindGold),
      purchasePhase
    };
  }

  @action.bound
  setConfig(viewModel) {
    this.account = viewModel.account;
    this.isReserved = viewModel.isReserved;
    this.serverName = viewModel.serverName;
    this.reservationCount = viewModel.reservationCount;
    this.bindGold = viewModel.bindGold;
    this.bindGoldText = viewModel.bindGoldText;
    this.purchasePhase = viewModel.purchasePhase;
  }

  async loadConfig() {
    try {
      this.setConfig(this.normalizeConfig(await this.$ztService.getConfig()));
    } catch (error) {
      return this.serverName;
    }
    return this.serverName;
  }

  use() {
    super.use();
    useMount(() => {
      this.loadConfig();
    });
  }
}

export default ActivityConfigStore;
